module.exports = __webpack_public_path__ + "static/media/cluster_4.3458ac7f.webp";